import React from 'react';
import { Markdown } from '@uplift/ui-v2';
import { CollaborativeAgreementSigned } from '@uplift/api';
import { useAgreementTemplateQuery, useCollaboratePhysicianMatchByIdForPhysicianQuery, useStateQuery, useUserDisplayNameQuery } from '@uplift/queries';
import { Box, Table, TableBody, TableRow, Typography } from '@mui/material';
import { CalendarDateService } from '@uplift/services';
import { DateFormats } from '@uplift/constants';
import { useCurrentuser, useTimezone } from '@uplift/contexts';
import { DetailsCell, DocumentLayout, EffectiveDateCell } from './components';


export const CollaborativeAgreementCounterSignedPreview: React.VFC<{
  document: CollaborativeAgreementSigned;
}> = ({
  document,
}) => {
  const me = useCurrentuser();
  const timezone = useTimezone();
  const { data: match } = useCollaboratePhysicianMatchByIdForPhysicianQuery(me.id, document.collaborativeMatchId);
  const { data: template } = useAgreementTemplateQuery(document.agreementTemplateId);
  const { data: state } = useStateQuery(match.stateId, { suspense: true });
  const { data: npName } = useUserDisplayNameQuery(match.providerId, { suspense: true });
  const { data: physicianName } = useUserDisplayNameQuery(match.collaborativePhysicianId, { suspense: true });

  return (
    <DocumentLayout
      title={template.name}
      subtitle="sent by uplift"
    >
      <Typography variant="overline" color="secondary">AGREEMENT DETAILS</Typography>
      <Table size="small" sx={{ 'tr:last-of-type td': { borderBottom: 0 } }}>
        <TableBody>
          <TableRow>
            <DetailsCell label="State Covered">{state.fullName}</DetailsCell>
            <DetailsCell label="Status">
              {document.counterSignedAt ? 'Active' : 'Awaiting counter-signature'}
            </DetailsCell>
          </TableRow>
          <TableRow>
            <EffectiveDateCell document={document} />
            <DetailsCell label="Expires">{CalendarDateService.date(document.expireAt, DateFormats.ISO_DATE).tz(timezone).format('MMM D, YYYY')}</DetailsCell>
          </TableRow>
          <TableRow>
            <DetailsCell label="Nurse Practitioner">{npName.defaultDisplay}</DetailsCell>
            <DetailsCell label="Collaborating Physician">{physicianName.defaultDisplay}</DetailsCell>
          </TableRow>
        </TableBody>
      </Table>

      <Box sx={{ mt: 2 }}>
        <Typography variant="overline" color="secondary">AGREEMENT TEXT</Typography>
        <Markdown>{document.content}</Markdown>
      </Box>
    </DocumentLayout>
  );
};
